import { Component, DestroyRef, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CmsContentItem, DefaultColorPickerValues } from '@coin/shared/cms/util';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SelectMediaComponent } from '../../../dialogs/shared/select-media/select-media.component';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ColorPickerComponent } from '@coin/shared/core/feature-legacy-components';
import { V2TextInputComponent, V2CheckboxComponent, V2ButtonComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'coin-a-email-header',
  templateUrl: './email-header.component.html',
  styleUrls: ['./email-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ColorPickerComponent,
    FormsModule,
    V2TextInputComponent,
    V2CheckboxComponent,
    V2ButtonComponent,
    TranslatePipe
  ]
})
export class EmailHeaderComponent implements OnInit {
  private readonly dialog = inject(MatDialog);
  private readonly destroyRef = inject(DestroyRef);

  @Input() item: CmsContentItem;
  @Input() showBackgroundPicker = false;

  ngOnInit(): void {
    this.item ??= {} as never;
    this.item.en ??= {} as never;
    this.item.en.sideData ??= {} as never;
    this.setDefaultColors();
  }

  private setDefaultColors(): void {
    this.item.en.sideData.backgroundColor =
      this.item.en.sideData.backgroundColor || DefaultColorPickerValues.backgroundColor;
    this.item.en.sideData.textColor = this.item.en.sideData.textColor || DefaultColorPickerValues.textColor;
  }

  editPicture(): void {
    SelectMediaComponent.openDialog(this.dialog, { mediaType: 'image' })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(newImage => {
        this.item.en['otherImage'] = '';
        if (newImage) {
          this.item.en['otherImage'] = newImage.mediaUrl;
        }
      });
  }
}
